import RouterLink from '@/react_app/common/RouterLink';
import { AppEmpty, AppButton } from '@/react_app/components/Atoms';
import { GETTING_STARTED_ROUTE_NAME } from '@/router/router.const';
export const PageNotFound = () => (
	<div className="width-100 h-[100vh] flex-centerize flex-column">
		<AppEmpty
			description={
				<div>
					<h1>Page Not Found</h1>
					<p>Sorry, the page you're looking for doesn't exist.</p>
				</div>
			}
		>
			<RouterLink to={{ name: GETTING_STARTED_ROUTE_NAME }}>
				<AppButton className="border-[#D9D9D9] text-purple-6">Return to home page</AppButton>
			</RouterLink>
		</AppEmpty>
	</div>
);
